import { authReducer, IAuthState } from "../auth/auth.reducer";
import {
  INodeState,
  nodeDetailsReducer,
} from "../nodeDetails/nodeDetails.reducer";
import { ICommonState, commonReducer } from "../common/common.reducer";
import {
  ISafetySensorState,
  sensorsReducer,
} from "../safetySensors/Sensors.reducer";

import { IMeterState, meterReducer } from "../meter/meter.reducer";

export interface IApplicationState {
  auth: IAuthState;
  node: INodeState;
  common: ICommonState;
  sensors: ISafetySensorState;
  meters: IMeterState;
}

export const reducers = {
  auth: authReducer,
  node: nodeDetailsReducer,
  common: commonReducer,
  sensors: sensorsReducer,
  meters: meterReducer,
};
